import { render, staticRenderFns } from "./TeamRooms.vue?vue&type=template&id=952bfdd6&scoped=true&"
import script from "./TeamRooms.vue?vue&type=script&lang=js&"
export * from "./TeamRooms.vue?vue&type=script&lang=js&"
import style0 from "./TeamRooms.vue?vue&type=style&index=0&id=952bfdd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952bfdd6",
  null
  
)

export default component.exports